/**
 * @generated SignedSource<<dfc8946903ad9cd82cab39c8b05ad246>>
 * @relayHash 1ba1230e03bd4bb49b14688808e1b46c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 041376b2b4fc1bf8e4dcf51a1f7662d343b972fb48cdba9021c721ba60e35883

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FieldSchemesAppQuery$variables = {
  cloudId: string;
};
export type FieldSchemesAppQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FieldSchemesPage">;
};
export type FieldSchemesAppQuery = {
  response: FieldSchemesAppQuery$data;
  variables: FieldSchemesAppQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "FieldSchemesAppQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "FieldSchemesPage"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FieldSchemesAppQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              }
            ],
            "concreteType": "JiraHomePage",
            "kind": "LinkedField",
            "name": "userHomePage",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "link"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "041376b2b4fc1bf8e4dcf51a1f7662d343b972fb48cdba9021c721ba60e35883",
    "metadata": {},
    "name": "FieldSchemesAppQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5d849fa3dc746f78acf5e0a8b2791820";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
